import { initializeApp } from "firebase/app";
import { getMessaging, onMessage } from "firebase/messaging";
import constants from "./constants";

var firebaseConfig = constants.firebaseKeys;



export const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);



